<template>
  <img v-if="url" :src="url" :alt="alt" class="max-w-full h-auto block" />
  <div v-else class="w-full h-full bg-gray-100"></div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { getUrl } from 'aws-amplify/storage';

const props = defineProps({
  imagePath: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    default: '',
  },
});

const url = ref(null);

const loadImage = async () => {
  if (!props.imagePath) {
    url.value = null;
    return;
  }
  try {
    // Assuming public access level as it was the default for amplify-s3-image if not specified
    // In Servers.vue upload logic: `public/${key}` is used, so we prepend public/ here.
    const result = await getUrl({
      path: `public/${props.imagePath}`,
    });
    url.value = result.url.toString();
  } catch (error) {
    console.error('Error loading S3 image:', error);
    url.value = null;
  }
};

watch(() => props.imagePath, loadImage, { immediate: true });
</script>
